import { useState, useEffect } from "react";
import Type4FullItineraryItemDetails from "../page_types/Type-4-page-components/Type4FullItineraryItemDetails";
import Type5FullItineraryItemDetails from "../page_types/Type-5-page-components/Type5FullItineraryItemDetails";

const ItineraryPreviewerPlus = (props) => {

    const {
        pageTheme,
        selectedItinerary,
        onBack,
    } = props;

    const [ itineraryTripDays, setItineraryTripDays ] = useState([]);

    useEffect(()=>{
        if(selectedItinerary?.trip_days){
            setItineraryTripDays(selectedItinerary?.trip_days);
        }else{
            let _trip_days = window.__generateItineraryTripDays(selectedItinerary);
            setItineraryTripDays(_trip_days);
        }
        window.scrollTo(0, 0);
        /*window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });*/
    }, [ selectedItinerary ]);

    const {
        packageTrendsPageType,
    } = pageTheme;

    const _PageType = parseInt(packageTrendsPageType);

    return <div>
        {
            _PageType === 4 &&
            <Type4FullItineraryItemDetails 
                pageTheme={pageTheme}
                itineraryTripDays={itineraryTripDays}
                itinerary={selectedItinerary}
                onBack={onBack}
            />
        }
        {
            _PageType === 5 &&
            <Type5FullItineraryItemDetails 
                pageTheme={pageTheme}
                itineraryTripDays={itineraryTripDays}
                itinerary={selectedItinerary}
                onBack={onBack}
            />
        }
    </div>
}

export default ItineraryPreviewerPlus;